module.exports = __webpack_public_path__ + "img/banks-imageNew-2.webp";